<template>
    <router-view :key="$route.fullPath"/>
</template>

<script>
export default {
  name: 'Credit',
  beforeRouteEnter (to, from, next) {
    next()
  }
}
</script>

<style scoped>

</style>
